import pushClevertapEvent from 'clevertap/pushClevertapEvent';

/**
 * Created by alvinoktavianus on 7/20/17.
 */
export function libraryGratuityStart({ currOutlet }) {
  pushClevertapEvent('Library Gratuity Start', {
    'Current Selected Outlet': currOutlet,
  });
}

export function libraryGratuityChangeOutlet({ previousOutlet, currOutlet }) {
  pushClevertapEvent('Library Gratuity Change Outlet', {
    'Previous Selected Outlet': previousOutlet,
    'Current Selected Outlet': currOutlet,
  });
}

export function libraryGratuityCreate({ values, isAllOutlet }) {
  const eventName = isAllOutlet
    ? 'Library Gratuity Create All Outlet'
    : 'Library Gratuity Create One Outlet';
  pushClevertapEvent(eventName, {
    Name: values.name,
    Value: values.amount,
  });
}

export function libraryGratuityDelete({ gratuity }) {
  pushClevertapEvent('Library Gratuity Delete', {
    Name: gratuity.name,
    Value: gratuity.amount,
  });
}

export function libraryGratuityUpdate({ oldValue, newValue }) {
  pushClevertapEvent('Library Gratuity Update One Outlet', {
    'Old Name': oldValue.name,
    'Old Value': oldValue.amount,
    'New Name': newValue.name,
    'New Value': newValue.amount,
  });
}
